module.exports = __webpack_public_path__ + "static/media/ic-alert-selected.2dfcd753.svg";